import { createAction, props } from '@ngrx/store';
import { ProviderCredential, ProviderCredentialPayload } from '../../../admin/admin.models';
import { Vehicle } from '../models/vehicle.class';
import { Fleet, FleetDTO, VehicleDTO } from '../models/vehicle.models';

export const getVehicleList = createAction('[Vehicle] Get Vehicle List');
export const setVehicleList = createAction(
  '[Vehicle] Set Vehicle List',
  props<{ vehicleList: Vehicle[] | null; noUpdate?: true }>()
);
export const createVehicleList = createAction(
  '[Vehicle] Create Vehicle List',
  props<{ vehicleList: VehicleDTO[]; tokenId?: number }>()
);
export const updateVehicleDetails = createAction(
  '[Vehicle] Update Vehicle List',
  props<{ vehicle: VehicleDTO }>()
);
export const deleteVehicleList = createAction(
  '[Vehicle] Delete From Vehicle List',
  props<{ vehicleIds: string[]; permanent?: boolean }>()
);
export const unarchiveVehicleList = createAction(
  '[Vehicle] Unarchive Vehicles',
  props<{ vehicleIds: string[] }>()
);

export const updateVehicleColor = createAction(
  '[Vehicle] Update Vehicle User Color',
  props<{ vehicleId: string; newColor: string }>()
);
export const setVehicleColor = createAction(
  '[Vehicle] Set Vehicle User Color',
  props<{ vehicleId: string; newColor: string }>()
);

export const getFleetList = createAction('[Vehicle] Get Vehicle Fleets');
export const setFleetList = createAction(
  '[Vehicle] Set Vehicle Fleets',
  props<{ fleetList: Fleet[] | null; noUpdate?: true }>()
);
export const createFleetList = createAction(
  '[Vehicle] Create Fleet List',
  props<{ fleetList: FleetDTO[] }>()
);
export const deleteFleetList = createAction(
  '[Vehicle] Delete Fleet List',
  props<{ fleetIds: number[] }>()
);
export const addToFleets = createAction(
  '[Vehicle] Add Vehicles to Fleets',
  props<{ fleets: number[]; vehicles: string[] }>()
);
export const removeFromFleets = createAction(
  '[Vehicle] Remove Vehicles From Fleets',
  props<{ fleets: number[]; vehicles: string[] }>()
);

export const getProviderCredentials = createAction('[Admin] Get Provider Credentials');
export const setProviderCredentials = createAction(
  '[Admin] Set Provider Credentials',
  props<{ providerCredentials: ProviderCredential[] | null; error?: string }>()
);
/**
 * Request creation of "For Business" credentials from a provider.
 * Associated effect invokes `setProviderCredentials` action on success
 */
export const createProviderCredentials = createAction(
  '[Admin] Create Provider Credentials',
  props<{ credentials: ProviderCredentialPayload[] }>()
);
export const deleteProviderCredentials = createAction(
  '[Admin] Delete Provider Credentials',
  props<{ credential: ProviderCredential }>()
);
